import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/very-dissatisfied-filled.vue
var o = {
	name: "DtIconVeryDissatisfiedFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--very-dissatisfied-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Very Dissatisfied Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M.391 6a5.438 5.438 0 1 1 10.875 0A5.438 5.438 0 0 1 .391 6ZM2.88 4.317a.438.438 0 0 1 .607-.123l.197.132c.19.125.436.125.624-.001l.194-.13a.438.438 0 0 1 .486.728l-.193.129a1.438 1.438 0 0 1-1.595.002l-.197-.13a.438.438 0 0 1-.123-.607Zm4.002.002a.437.437 0 0 1 .606-.122l.197.131c.19.126.436.126.624 0l.194-.13a.437.437 0 1 1 .486.727l-.193.13a1.437 1.437 0 0 1-1.595.002l-.197-.131a.437.437 0 0 1-.122-.607Zm-.993 1.803a2.579 2.579 0 0 0-1.57.505 2.206 2.206 0 0 0-.86 1.352.437.437 0 0 0 .43.518h4a.438.438 0 0 0 .43-.518 2.206 2.206 0 0 0-.859-1.352 2.579 2.579 0 0 0-1.57-.505Zm-.005.875a1.704 1.704 0 0 0-1.04.33 1.442 1.442 0 0 0-.296.295H7.23a1.442 1.442 0 0 0-.295-.295 1.704 1.704 0 0 0-1.04-.33h-.011Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=very-dissatisfied-filled.js.map